import axios from "axios";

import { BASEURL } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";

export function ApiFund() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const url = BASEURL + "fundsmanagement/";
  return {
    addFund: (newRecord) =>
      authAxios.post(url + "addInfaqCashInHand/", newRecord),
    addSingleInfaqAmanat: (newRecord) =>
      authAxios.post(url + "AddInfaqAmanatAccount/", newRecord, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    getInfaqRequestDetail: (notificationId) =>
      authAxios.get(`${url}GetInfaqRequestDetail/${notificationId}`),
    UpdateNotificationInfaqToAmanat: (record) =>
      authAxios.post(url + "UpdateNotificationInfaqToAmanat", record),
    addBulkFund: (newRecord) => authAxios.post(url + "addBulk/", newRecord),
    getMembersFundsDetails: (newRecord) =>
      authAxios.post(url + "getMembersFundsDetails/", newRecord),
    getUnitWiseFundsDetails: (newRecord) =>
      authAxios.post(url + "GetUnitWiseFundsDetails/", newRecord),
    getList: (unitId, memberId) =>
      authAxios.get(url + "getList/" + unitId + "/" + memberId),
    getById: (id) => authAxios.get(url + "edit/" + id),
    update: (id, updateRecord) =>
      authAxios.put(url + "edit/" + id, updateRecord),
    deleteFund: (id, type) => authAxios.delete(url + "delete/" + id + "/" + type),
    GetUnitWiseFundsDetailsExcelReport: (newRecord) =>
      authAxios.post(url + "GetUnitWiseFundsDetailsExcelReport/", newRecord, {
        responseType: "blob",
      }),
    GetUnitWiseFundsDetailsPdfReport: (newRecord) =>
      authAxios.post(url + "GetUnitWiseFundsDetailsPdfReport/", newRecord, {
        responseType: "blob",
      }),

    GetMembersFundsDetailsPdfReport: (newRecord) =>
      authAxios.post(url + "GetMembersFundsDetailsPdfReport/", newRecord, {
        responseType: "blob",
      }),

    GetMembersFundsDetailsExcelReport: (newRecord) =>
      authAxios.post(url + "GetMembersFundsDetailsExcelReport/", newRecord, {
        responseType: "blob",
      }),
    GetInfaqTransactions: (record) =>
      authAxios.post(url + "GetInfaqTransactions", record),
    
  };
}
